import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from "@angular/core";
import { BaseFormComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-form.component";
import { SaleMethod } from "../../model/sale-method.model";
import { SelectorService } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/selector.service";
import { delay, take } from "rxjs/operators";
import { CheckBrachAccessModel } from "src/app/gnr/data-center-process/chek-branch-access.model";

@Component({
  selector: "ngx-sale-method-form",
  templateUrl: "./sale-method-form.component.html",
  styleUrls: ["./sale-method-form.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SaleMethodFormComponent extends BaseFormComponent<SaleMethod> {
  deactivateSave: boolean;

  constructor(protected selectorService: SelectorService, protected cd: ChangeDetectorRef) {
    super(selectorService, cd);
  }

  async ngOnInit() {
    this.apiName = "SaleMethod";
    this.label = this.translate("ClientApp.FrontOffice.SALE.SaleMethod.SaleMethod");
    super.ngOnInit();
    this.FillData();
    this.checkAccessToChangeSaleMethodNature();
  }

  checkAccessToChangeSaleMethodNature() {
    if (this.currentrow) {
      this.httpCommonService
        .get("SaleMethod/HasAccessToChangeSaleMethodNature?saleMethodId=" + this.currentrow.Id)
        .pipe(take(1), delay(200))
        .subscribe((hasAccess) => {
          if (!hasAccess) this.formGroup.controls["SaleMethodNatureId"].disable();
        });
    }
  }

  async FillData() {
    // چک کردن انتقال اطلاعات مدیریت شعب
    const currentInformation = this.accountService.authService.currentInformation();
    if (currentInformation.BranchingLightEnabled || currentInformation.BranchingAdvancedEnabled) {
      this.httpCommonService
        .getList("UserLocalSetting/GetValidationBranch/SaleMethod")
        .pipe(take(1))
        .subscribe(
          (hbc: CheckBrachAccessModel) => {
            if ((hbc.TransferKindCode == 2 || hbc.TransferKindCode == 5) && hbc.HasCommunication == true && hbc.BranchCount == 1) {
              this.sts.showDialog(
                this.translate("ClientApp.FrontOffice.SALE.SaleMethod.HasBranchCommunication"),
                this.translate("ClientApp.FrontOffice.SALE.SaleMethod.Attention")
              );
              this.deactivateSave = true;
              return;
            } else if ((hbc.TransferKindCode == 1 || hbc.TransferKindCode == 4) && hbc.BranchCount > 1) {
              this.sts.showDialog(
                this.translate("ClientApp.FrontOffice.SALE.SaleMethod.HasCallCenterCommunication"),
                this.translate("ClientApp.FrontOffice.SALE.SaleMethod.Attention")
              );
              this.deactivateSave = true;
              return;
            }
          },
          (error) => this.getFailedHelper(error)
        );
    }
  }
}
